// extracted by mini-css-extract-plugin
export default {"sectionTitle":"kuZcPC","faqsTitle":"Wq27HU","faqQuestionTitle":"ZXKhho","faqs":"ILirwC","faqsHarmony":"sxpjrX"};